import React from 'react';
import {
  Box,
  Button,
  TextField,
} from '@mui/material';

const BulkUploadPanelFormActionsSection = ({
  showDetailFields = false,
  batchName = '',
  description = '',
  onBatchNameChange = () => undefined,
  onDescriptionChange = () => undefined,
  nameMissing = false,
  onCancel = () => undefined,
  onSubmit = () => undefined,
  selectedFile = null,
  hasRequiredVow = false,
  isSubmitting = false,
  isValidating = false,
  isSubmitLocked = false,
}) => {
  const normalizedBatchName = String(batchName || '');
  const normalizedDescription = String(description || '');

  return (
    <>
      {showDetailFields && (
        <Box sx={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <TextField
            label="Batch Name"
            value={normalizedBatchName}
            onChange={(event) => onBatchNameChange(event.target.value)}
            fullWidth
            size="small"
            required
            error={nameMissing}
            helperText="Give this upload a name so you and your team can find it later."
          />
          <TextField
            label="Description"
            value={normalizedDescription}
            onChange={(event) => onDescriptionChange(event.target.value)}
            fullWidth
            multiline
            rows={4}
            helperText="Optional. Add context about what's in this batch or why it was uploaded (e.g., time range, customer segment)."
          />
        </Box>
      )}

      <Box sx={{ marginTop: '2rem', display: 'flex', justifyContent: 'space-between', paddingTop: '0.5rem' }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderColor: 'emphasis.dark',
            color: 'emphasis.dark',
            minWidth: '110px',
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={
            !selectedFile
            || !normalizedBatchName.trim()
            || !hasRequiredVow
            || isSubmitting
            || isValidating
            || isSubmitLocked
          }
          onClick={onSubmit}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            minWidth: '140px',
          }}
        >
          {isValidating ? 'Validating...' : isSubmitting ? 'Submitting...' : 'Submit orders'}
        </Button>
      </Box>
    </>
  );
};

export default BulkUploadPanelFormActionsSection;
